import React from 'react';
import {
  SwipeableDrawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Icon,
  Stack,
} from '@mui/material';
import { useLocation, useNavigate, matchPath } from 'react-router';
// COMPONENTS
import ThemeSwitcher from '../../../../components/Button/ThemeSwitcher';
// NAVIGATION
import {
  ADMIN_NAVIGATION_ROUTES,
  INavigationRoutes,
} from '../../../../navigation';
// HOOKS
import { useAppSelector } from '../../../../hooks';
// STORE
import { getAuthState } from '../../../../store/AuthSlice';

interface IProps {
  open: boolean;
  toggle: () => void;
}

const Drawer: React.FC<IProps> = ({ open, toggle }) => {
  // HOOKS
  const location = useLocation();
  const navigate = useNavigate();
  const authState = useAppSelector(getAuthState);

  const authUser = authState.user;

  const filterTutorNavigations = (navigationRoute: INavigationRoutes) => {
    if (authUser && authUser.role && authUser.role.name === 'Tutor') {
      return (
        navigationRoute.key === 'dashboard' ||
        navigationRoute.key === 'students'
      );
    }
    return true;
  };

  // RENDER
  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onOpen={() => toggle()}
      onClose={() => toggle()}
      PaperProps={{ style: { maxWidth: '250px' } }}
    >
      <Box
        role="presentation"
        sx={{
          height: '100%',
          p: '50px 15px 15px 15px',
        }}
      >
        <Stack justifyContent="space-between" sx={{ height: '100%' }}>
          <div>
            <a
              href={`${process.env.PUBLIC_URL}/dashboard`}
              style={{ marginRight: '10px' }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/logos/tp-logo-text-green.png`}
                alt="tutopiya-logo"
                style={{ height: '30px' }}
              />
            </a>
            <List sx={{ mt: '30px' }}>
              {ADMIN_NAVIGATION_ROUTES.filter(filterTutorNavigations).map(
                (adminNavigationRoute: INavigationRoutes, index: number) => {
                  let isMatch = false;
                  const isSelected =
                    location.pathname === adminNavigationRoute.pathname;

                  if (
                    adminNavigationRoute.matches &&
                    adminNavigationRoute.matches.length > 0
                  ) {
                    adminNavigationRoute.matches.forEach((match) => {
                      if (
                        matchPath(match, location.pathname) &&
                        isMatch === false
                      ) {
                        isMatch = true;
                      }
                    });
                  }

                  const handleNavigationChange = () => {
                    if (!isSelected) {
                      setTimeout(() => {
                        navigate(adminNavigationRoute.pathname);
                        toggle();
                      }, 250);
                    } else {
                      toggle();
                    }
                  };

                  const isActive = isMatch || isSelected;

                  return (
                    <ListItem key={index} disablePadding sx={{ mb: '5px' }}>
                      <ListItemButton
                        selected={isActive}
                        sx={{ borderRadius: '7px' }}
                        onClick={handleNavigationChange}
                      >
                        <ListItemIcon>
                          <Icon
                            color={isActive ? 'primary' : 'inherit'}
                            component={adminNavigationRoute.icon}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={adminNavigationRoute.name}
                          primaryTypographyProps={{
                            color: isActive ? 'primary' : 'secondary',
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                }
              )}
            </List>
          </div>
          <div>
            <Stack alignItems="center">
              <ThemeSwitcher toggleDrawer={toggle} />
            </Stack>
          </div>
        </Stack>
      </Box>
    </SwipeableDrawer>
  );
};

export default Drawer;
